export function validateString(inputStr: string) {
    return (inputStr.trim().length >= 1);
}
